const SEND_EMAIL_SUCCESS_TEXT = "redux_store:marketing.success.send_email";
export const SEND_EMAIL_SUCCESS = SEND_EMAIL_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/marketing.js